import { getAuthForVisitorPresenceSocket, setVisitorPresenceApiBase } from 'api/auth'
import { getAuthForSocketConnection } from 'modules/session/utils'
import { generatePresenceContext } from 'modules/visitorPresence'
import { Channel, Socket } from 'phoenix'
import { CHANNEL_EVENTS, connectToChannel, connectToSocket,SOCKET_CHANNELS, SOCKET_CLUSTER } from 'utils/socket'

import { PRESENCE_UPDATE_HEARTBEAT_INTERVAL } from '../constants'
import SocketManager from '../socketManager'

interface SocketConnectProps {
  orgId: number,
  accessToken: string,
}

class VisitorPresenceSocketManager extends SocketManager {
  _heartbeatInterval: number
  _socket: Socket
  _channel: { channel: Channel }

  constructor() {
    super()
    this._socket = null
    this._channel = null
    this._heartbeatInterval = null
  }

  async connect({ orgId, accessToken }: SocketConnectProps) {
    setVisitorPresenceApiBase()

    const socketPresenceAuth = await getAuthForSocketConnection({
      fn: getAuthForVisitorPresenceSocket,
      socketCluster: SOCKET_CLUSTER.VISITOR_PRESENCE,
      token: accessToken
    })


    this._socket = await connectToSocket({
      ip: socketPresenceAuth.remote_ip,
      org_id: orgId,
      session_token: socketPresenceAuth.session_token,
      socketCluster: SOCKET_CLUSTER.VISITOR_PRESENCE,
    })

    this._fireSocketConnectedEvent(SOCKET_CLUSTER.VISITOR_PRESENCE)

    this._channel = await connectToChannel({
      socket: this._socket,
      channelEvents: CHANNEL_EVENTS.PRESENCE,
      channelName: SOCKET_CHANNELS.LIVE,
      orgId,
      socketAuth: socketPresenceAuth,
    })

    this._fireChannelConnectedEvent('user', SOCKET_CLUSTER.VISITOR_PRESENCE, this._channel)

    if (this._channel) {
      this._updatePresence()
      this.startPresenceUpdateHeartbeat()
    }
  }

  startPresenceUpdateHeartbeat() {
    this._heartbeatInterval = window.setInterval(this._updatePresence.bind(this), PRESENCE_UPDATE_HEARTBEAT_INTERVAL)
  }

  async _updatePresence() {
    if (!this._channel) {
      return
    }

    const context = await generatePresenceContext()
    this._channel.channel.push('heartbeat', context)
  }

  stopPresenceUpdateHeartbeat() {
    window.clearInterval(this._heartbeatInterval)
  }
}

export default new VisitorPresenceSocketManager()
